import { clienteAxios, updateHeader } from "../config/axios"
import { history } from "../helpers/history"
import axios from "./axios"
import { authHeader } from "../helpers/auth-header"
import { clearLocalStorage } from "../utils"

const getAuditDetails = async (data) => {
	const user = JSON.parse(localStorage.getItem("user")).token
	return await axios.get(`/audit/${user?.userid}?limit=${data?.limit}&${data?.actions}`).then((data) => {
		return data
	})
}

export const auditService = {
	getAuditDetails,
}
